import { Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import PageLayout from "app/components/ui/PageLayout/PageLayout";
import { routeConfig } from "./routeConfig";
import AppLoader from "../widgets/loader";

const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const RouteManager = () => {
  const location = useLocation();

  return (
    <PageLayout>
      <Suspense fallback={<AppLoader width={60} height={60} />}>
        <Routes location={location} key={location.pathname}>
          {Object.entries(routeConfig).map(([key, route]) => {
            const Component = route.component;

            return (
              <Route
                key={key}
                path={route.path}
                element={
                  <motion.div
                    variants={pageVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    transition={{ duration: 0.25 }}
                    style={{ height: "100%" }}
                  >
                    <Component />
                  </motion.div>
                }
              />
            );
          })}
        </Routes>
      </Suspense>
    </PageLayout>
  );
};

export default RouteManager;

